import { render, staticRenderFns } from "./FirstScan.vue?vue&type=template&id=2bf0a39c&scoped=true"
import script from "./FirstScan.vue?vue&type=script&lang=js"
export * from "./FirstScan.vue?vue&type=script&lang=js"
import style0 from "./FirstScan.vue?vue&type=style&index=0&id=2bf0a39c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf0a39c",
  null
  
)

export default component.exports